import { combineReducers } from 'redux';
import auth from './auth/authReducer';
import jobs from './jobs/jobsReducer';
import requests from './requests/requestsReducer';
import titles from './titles/titlesReducer';
import openweb from './openweb/openwebReducer';
import owp from './owp/owpReducer';
import dashboard from './dashboard/dashboardReducer';
import agencies from './agencies/agenciesReducer';

const rootReducer = combineReducers({
  auth,
  jobs,
  requests,
  titles,
  openweb,
  owp,
  dashboard,
  agencies,
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/data/rootReducer.js